import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Alert, Button } from "antd";
import UnitOfMeasureType from "../enums/UnitOfMeasureType";
import axios from "axios";
import SenderReceiverProductCatalogueStatusType from "../enums/SenderReceiverProductCatalogueStatusType";
import SenderReceiverSelectTable from "./SenderReceiverSelectTable";
import { axiosErrorHandler } from "../../../swzutils";
const WaypointSenderReceiverProductValidator = (props) => {
    const [stateLoadingLocationsWithProducts, setStateLoadingLocationsWithProducts] = useState(false);
    const [stateLocationsWithProducts, setStateLocationsWithProducts] = useState(null);
    const [stateProductCatalogueStatus, setStateProductCatalogueStatus] = useState(null);
    const [stateErrorMessage, setStateErrorMessage] = useState(null);
    useEffect(() => {
        if (props.consignmentId && props.waypointId && props.senderReceiverId) {
            validateSenderReceiverProducts();
        }
    }, [props.consignmentId, props.waypointId, props.senderReceiverId]);
    useEffect(() => {
        propagateValidation();
    }, [stateProductCatalogueStatus]);
    useEffect(() => {
        const absentProducts = stateProductCatalogueStatus?.absentProducts ?? [];
        const issues = stateProductCatalogueStatus?.issues ?? [];
        const senderReceiverSelected = !!props.senderReceiverId;
        // Only show when no sender receiver is selected OR the selected one has issues
        if (!senderReceiverSelected || (absentProducts.length > 0 || issues.length > 0)) {
            findSenderReceiverCandidatesByDistance();
        }
    }, [stateProductCatalogueStatus?.absentProducts?.length, stateProductCatalogueStatus?.issues.length, props.senderReceiverId]);
    const isSenderReceiverProductCatalogueInUse = () => {
        return isSenderReceiverProductCatalogueEnabled() || isSenderReceiverProductCatalogueEnforced();
    };
    const isSenderReceiverProductCatalogueEnabled = () => {
        const settings = props.tenantSettings;
        if (settings && settings.senderReceiverProductCatalogue) {
            return SenderReceiverProductCatalogueStatusType.ENABLED === SenderReceiverProductCatalogueStatusType.valueOf(settings.senderReceiverProductCatalogue);
        }
        return false;
    };
    const isSenderReceiverProductCatalogueEnforced = () => {
        const settings = props.tenantSettings;
        if (settings && settings.senderReceiverProductCatalogue) {
            return SenderReceiverProductCatalogueStatusType.ENFORCED === SenderReceiverProductCatalogueStatusType.valueOf(settings.senderReceiverProductCatalogue);
        }
        return false;
    };
    const isValid = () => {
        if (isSenderReceiverProductCatalogueEnforced()) {
            if (stateProductCatalogueStatus?.absentProducts?.length || stateProductCatalogueStatus?.issues?.length) {
                return false;
            }
        }
        return true;
    };
    const propagateValidation = () => {
        props.onValidationChanged(isValid());
    };
    const validateSenderReceiverProducts = () => {
        if (isSenderReceiverProductCatalogueInUse()) {
            const { consignmentId, waypointId, senderReceiverId } = props;
            if (consignmentId && waypointId && senderReceiverId) {
                axios.get(`/admin/v1/consignments/${consignmentId}/waypoints/${waypointId}/sender-receivers/${senderReceiverId}/product-catalogue-status`)
                    .then((response) => {
                    setStateProductCatalogueStatus(response.data);
                }).catch(axiosErrorHandler);
            }
        }
    };
    const findSenderReceiverCandidatesByDistance = () => {
        if (isSenderReceiverProductCatalogueInUse()) {
            const { consignmentId, waypointId } = props;
            setStateLocationsWithProducts(null);
            setStateLoadingLocationsWithProducts(true);
            axios.get(`/admin/v1/consignments/${consignmentId}/waypoints/${waypointId}/sender-receivers/pickup`)
                .then((response) => {
                // props.onSenderReceiverSelected(response.data);
                setStateLocationsWithProducts(response.data);
                setStateErrorMessage(null);
            })
                .catch(error => {
                if (error.response && 404 === error.response.status) {
                    setStateErrorMessage("Unable to find a saved location with all products");
                }
            })
                .finally(() => {
                setStateLoadingLocationsWithProducts(false);
            });
        }
    };
    if (isSenderReceiverProductCatalogueInUse()) {
        return (_jsxs(_Fragment, { children: [(!isValid()) &&
                    _jsx(Alert, { type: "warning", title: "Warning", description: _jsxs(_Fragment, { children: [_jsx("ul", { children: stateProductCatalogueStatus?.issues
                                        .map((value, index) => _jsx("li", { children: value }, index)) }), (stateProductCatalogueStatus?.absentProducts && stateProductCatalogueStatus?.absentProducts.length > 0) &&
                                    _jsx("p", { children: "Missing products" }), _jsx("ul", { children: stateProductCatalogueStatus?.absentProducts.map(it => {
                                        const uomType = UnitOfMeasureType.valueOf(it.unitOfMeasure);
                                        return _jsxs("li", { children: [it.productReference, " \u00A0-\u00A0 ", it.productDescription, "\u00A0\u00A0", _jsx("em", { children: uomType == null ? '' : uomType.description })] }, it.id);
                                    }) })] }), showIcon: true }), (stateErrorMessage) &&
                    _jsx(Alert, { style: { marginTop: '10px' }, type: "error", title: stateErrorMessage }), (stateLocationsWithProducts == null && stateProductCatalogueStatus != null) &&
                    _jsx(Button, { onClick: findSenderReceiverCandidatesByDistance, loading: stateLoadingLocationsWithProducts, children: "Show Alternative Locations With All Products" }), stateLocationsWithProducts != null &&
                    _jsxs(_Fragment, { children: [(stateLocationsWithProducts.length > 0) &&
                                _jsxs(_Fragment, { children: [_jsx("p", { children: "The following locations have all products available" }), _jsx(SenderReceiverSelectTable, { loading: stateLoadingLocationsWithProducts, senderReceivers: stateLocationsWithProducts, onSelected: (sr) => props.onSenderReceiverSelected(sr) })] }), (stateLocationsWithProducts.length === 0 && !stateLoadingLocationsWithProducts) &&
                                _jsx(_Fragment, { children: _jsx(Alert, { style: { marginTop: '10px' }, type: "error", showIcon: true, title: "Unable to find a saved location with all products" }) })] })] }));
    }
    return null;
};
export default WaypointSenderReceiverProductValidator;
